module.exports = __webpack_public_path__ + "img/yingshang.1a18f81c.png";